import React, { Component } from 'react';
import '../static/css/bootstrap.min.css'
import '../index.css'


class Section12 extends Component {
  render() {
    return (
      <section id="page_12">
        <div className="container">
          <div className="row">
            <div className="col-sm-offset-3 col-sm-6 col-xs-12">
              <div className="title text-center">
                万全のサポート
              </div>

              <div className="content">
                勉強方法やMusioの使い方などでご不明な点がございましたら、<br />
                サポートセンターまでお問い合わせください。
              </div>

              <div className="info">
                Musioサポートセンター
                <ul className="info_line">
                  <li>電話： 03-6886-5229</li>
                  <li>お問い合わせフォーム： info-jp@akaintelligence.com</li>
                  <li>受付時間： 11:00~19:00（※年末年始、毎週火曜日・祝日を除く）</li>
                </ul>
              </div>
              <div>
                <div className="col-xs-5" id="additional_info">
                  <div className="additional_info">
                    Musio X 本体
                  </div>
                  <div className="additional_info">
                    Academy Mode
                  </div>
                  <div className="additional_info">
                    生徒学習管理機能
                  </div>
                  <div className="additional_info">
                    コンテンツ編集機能
                  </div>
                </div>

                <div className="col-xs-7">
                  <div className="additional_info">
                    マニュアルガイドは<a href="https://s3-ap-northeast-1.amazonaws.com/b2b-landing/pdf/Musio+X+%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB.pdf">こちら</a>
                  </div>
                  <div className="additional_info">
                    マニュアルガイドは<a href="https://s3-ap-northeast-1.amazonaws.com/b2b-landing/pdf/Academy+Mode+%E3%83%A6%E3%83%BC%E3%82%B6%E3%83%BC%E3%82%AC%E3%82%A4%E3%83%89.pdf">こちら</a>
                  </div>
                  <div className="additional_info">
                    マニュアルガイドは<a href="https://s3-ap-northeast-1.amazonaws.com/b2b-landing/pdf/%E7%94%9F%E5%BE%92%E3%81%AE%E5%AD%A6%E7%BF%92%E7%AE%A1%E7%90%86%E6%A9%9F%E8%83%BD+%E3%83%A6%E3%83%BC%E3%82%B6%E3%83%BC%E3%82%AC%E3%82%A4%E3%83%89.pdf">こちら</a>
                  </div>
                  <div className="additional_info">
                    マニュアルガイドは<a href="https://s3-ap-northeast-1.amazonaws.com/b2b-landing/pdf/Musio+Academy+Plan+%E3%82%B3%E3%83%B3%E3%83%86%E3%83%B3%E3%83%84%E7%B7%A8%E9%9B%86%E6%A9%9F%E8%83%BD%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB.pdf">こちら</a>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>
    );
  }
}

export default Section12;



// WEBPACK FOOTER //
// ./src/sections/Section12.js